import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import DownloadOpmerkingen from '../components/DownloadOpmerkingen.vue';
import DownloadKeuringen from '../components/export/DownloadKeuringen.vue';
import DownloadKeuringsOpmerkingen from '../components/export/DownloadKeuringsOpmerkingen.vue';
import RelatieUnitsOverzicht from '../views/settings/RelatieUnitsOverzicht.vue';
import RelatieUnitsData from '../views/settings/RelatieUnitsData.vue';
import UnitsFinancieel from '../components/UnitsFinancieel.vue';
import KeuringenQueue from "../components/keuringen/KeuringenQueue.vue";
import KeuringQueueDetail from "../components/keuringen/KeuringQueueDetail.vue";
import KeuringenVerwerkt from "../components/keuringen/KeuringenVerwerkt.vue";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const UserSettings = () => import("@/views/settings/UserSettings");

// views - TPA dashboard
const Dash = () => import("@/views/Transplan");

//views - settings
const Relaties = () => import("@/views/settings/Relaties");
const Relatie = () => import("@/views/settings/Relatie");
const RelatieDashboard = () => import("@/views/settings/RelatieDashboard");
const RelatieEdit = () => import("@/views/settings/RelatieEdit");
const RelatieContactpersonen = () =>
  import("@/views/settings/RelatieContactpersonen");
const RelatieUnits = () => import("@/views/settings/RelatieUnits");
const RelatieAPIKeys = () => import("@/views/settings/RelatieApiKeys");
const RelatieHerinnering = () => import("@/views/settings/RelatieHerinnering");
const RelatieDocumenten = () => import("@/views/settings/RelatieDocumenten");
const RelatieImportStatus = () => import("@/views/settings/RelatieImportStatus");
const RelatieContractDocumenten = () => import("@/views/settings/RelatieContracten");

//views - administratie
const Facturen = () => import("@/views/administratie/facturatie/Facturen");
const Factuur = () => import("@/views/administratie/facturatie/Factuur");

const Offertes = () => import("@/views/administratie/verkoop/Offertes");
const Offerte = () => import("@/views/administratie/verkoop/Offerte");
const Opdracht = () => import("@/views/administratie/verkoop/Opdracht");
const Herinspecties = () => import("@/views/administratie/planning/Herinspecties");

const LiftManagementView = () => import("@/views/administratie/management/LiftManagementView");
const Traject = () => import("@/views/administratie/management/Traject");

const Documenten = () => import("@/views/administratie/documenten/Documenten");
const DocumentenView = () =>
  import("@/views/administratie/documenten/DocumentenView");
const Document = () => import("@/views/administratie/documenten/Document");
const DocumentenUpload = () =>
  import("@/views/administratie/documenten/DocumentenUpload");
const SecureUpload = () =>
  import("@/views/administratie/documenten/SecureUpload");

  // DOCPARSER
const Parsed = () =>
  import("@/views/administratie/documenten/docparser/Parsed");
const Parsing = () => import("@/views/administratie/documenten/docparser/Parsing");
const Parsers = () => import("@/views/administratie/documenten/docparser/Parsers");
  // DOCPARSER

const KpiTemplate = () => import("@/views/kpi/KpiTemplate");
const KpiOverzicht = () => import("@/views/kpi/KpiOverzicht");
// const KpiDashboard = () => import("@/views/kpi/KpiDashboard");
const KpiDetail = () => import("@/views/kpi/KpiDetail");

const Templates = () => import("@/views/administratie/templates/TemplatesView");
const Elementen = () => import("@/views/administratie/ElementenView");

const InspectiesDashboard = () =>
  import("@/views/administratie/inspecties/Dashboard");
const InspectiePrognosesView = () =>
  import("@/views/administratie/InspectiePrognosesView");

const OpenstaandView = () => import("@/views/status/OpenstaandView");
const Indexeringen = () => import("@/views/administratie/IndexeringView");
const ExcelExports = () => import("@/views/administratie/ExcelExports");

const Unit = () => import("@/views/UnitView");
const UnitWizard = () => import("@/views/units/UnitWizard");
const TabAlgemeen = () => import("@/views/units/TabAlgemeen");
const TabPlanning = () => import("@/views/units/TabPlanning");
const TabPrognose = () => import("@/views/units/TabPrognose");
const TabInventarisatie = () => import("@/views/units/TabInventarisatie");
const TabPrognoses = () => import("@/views/units/TabPrognoses");
const TabDashboard = () => import("@/views/units/TabDashboard");
const TabFotos = () => import("@/views/units/TabFotos");
const TabKpi = () => import("@/views/units/TabKpi");
const TabExport = () => import("@/views/units/TabExport");
const TabService = () => import("@/views/units/TabService");
const TabRelatie = () => import("@/views/units/TabRelatie");
const TabDocumenten = () => import("@/views/units/TabDocumenten");
const TabOplevering = () => import("@/views/units/TabOplevering");
const TabOpleveringen = () => import("@/views/units/TabOpleveringen");

const Authenticatie = () => import("@/views/profiel/Auth");
const OverviewComplexen = () => import("@/views/complex/ComplexenView");
const OverviewUnits = () => import("@/views/units/OverviewUnits.vue");

const InventarisatieStaatExport = () =>
  import("@/views/export/InventarisatieStaatExport");

const Login = () => import("@/views/pages/Login");
Vue.use(Router);

const r = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dash",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "auth",
          name: "Authenticatie",
          component: Authenticatie
        },
        {
          path: "dash",
          name: "Transplan",
          component: Dash
        },
        {
          path: "dashboard",
          name: "Dashboard",
          meta: { label: "Taakvoortgang" },
          component: Dashboard
        },
        {
          path: "instellingen",
          name: "UserSettings",
          meta: { label: "Instellingen" },
          component: UserSettings
        },
        {
          path: "/export/inventarisatie",
          name: "ExportInventarisatie",
          component: InventarisatieStaatExport
        },
        {
          path: "units",
          name: "UnitOverzicht",
          meta: { label: "Overzicht van units" },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              name: "UnitsLegacyOverview",
              meta: { label: "Overzicht van units" },
              component: OverviewUnits
            }
          ]
        },
        {
          path: "complexen",
          name: "ComplexenOverzicht",
          meta: { label: "Overzicht van complexen" },
          component: OverviewComplexen
        },
        {
          path: "kpi",
          redirect: "kpi/overzicht",
          component: KpiTemplate,
          children: [
            {
              name: "KPIOverzicht",
              path: "overzicht",
              props: true,
              component: KpiOverzicht,   
            },
            {
              path: ":detail",
              props: true,
              name: "KPIDetail",
              component: KpiDetail
            },
          ]
        },
        {
          path: "unitwizard",
          name: "UnitWizard",
          component: UnitWizard
        },
        {
          path: "unit/:id",
          name: "UnitViewRoute",
          meta: { label: "Unit" },
          redirect: "unit/:id/algemeen",
          props: route => ({ id: Number(route.params.id) }),
          component: Unit,
          children: [
            {
              path: "dashboard",
              name: "DashboardUnit",
              component: TabDashboard
            },
            {
              path: "algemeen",
              name: "Algemeen",
              component: TabAlgemeen
            },
            {
              path: "inventarisatie",
              name: "Inventarisatie",
              component: TabInventarisatie
            },
            {
              path: "specifiek",
              name: "Specifiek",
              component: TabPrognose
            },
            {
              path: "inspectie",
              name: "Inspectie",
              component: TabPrognose
            },
            {
              path: "prognoses",
              name: "Prognoses",
              props: true,
              component: TabPrognoses
            },
            {
              path: "prognose/:prognoseid",
              name: "Prognose",
              props: true,
              component: TabPrognose
            },
            {
              path: "fotos",
              name: "Fotoboek",
              component: TabFotos
            },
            {
              path: "kpi",
              name: "KPI",
              component: TabKpi
            },
            {
              path: "documenten",
              name: "DocumentenUnit",
              component: TabDocumenten
            },
            {
              path: "planning",
              name: "Planning",
              component: TabPlanning
            },
            {
              path: "service",
              name: "Service",
              component: TabService
            },
            {
              path: "export",
              name: "Export",
              component: TabExport
            },
            {
              path: "oplevering",
              name: "Oplevering",
              component: TabOplevering
            },
            {
              path: "opleveringen",
              name: "Opleveringen",
              component: TabOpleveringen
            },
            {
              path: "relatie",
              name: "RelatieUnit",
              component: TabRelatie
            }
          ]
        },
        {
          path: "test",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "secure-upload",
              name: "SecureUpload",
              component: SecureUpload
            }
          ]
        },
        {
            name: "docparser-parsings",
            path: "/docparser",
            redirect: "/docparser/list/new",
            component: {
              render(c) {
                return c("router-view");
              }
            },
            children: [
              {
                path: "upload",
                props: true,
                name: "docparser-upload",
                component: Parsers,
              },
              {
                path: "list/:type",
                props: true,
                name: "docparser-parsings-list",
                component: Parsed,
              },
              {
                path: ":id",
                props: route => ({ id: Number(route.params.id) }),
                name: "docparser-parsing",
                component: Parsing
              }
            ]
        },
        {
          path: "upload",
          name: "upload-documenten",
          component: DocumentenUpload
        },
        {
          path: "documenten/:jaar",
          component: DocumentenView,
          name: "Documenten",
          meta: { label: "Documenten" },
          props: route => ({ jaar: Number(route.params.jaar) }),
          redirect: "documenten/:jaar/overzicht",
          children: [
            {
              path: "overzicht",
              name: "VerwerkteDocumenten",
              component: Documenten
            },
            {
              path: "document/:id",
              name: "Document",
              props: route => ({
                jaar: Number(route.params.jaar),
                id: Number(route.params.id)
              }),
              component: Document
            },
            {
              path: "overzicht/teverwerken",
              meta: { label: "Te verwerken" },
              name: "TeVerwerkenDocumenten",
              component: Documenten
            },
          ]
        },
        {
          path: "templates",
          component: Templates
        },
        {
          path: "elementen",
          component: Elementen
        },
        {
          path: "inspecties",
          name: "controle dashboard",
          component: InspectiesDashboard,
          redirect: "inspecties/nieuwer",
          children: [
            {
              meta: { label: "Nieuwere inspecties beschikbaar" },
              path: "nieuwer",
              name: "Nieuwere inspecties",
              component: InspectiePrognosesView
            }
          ]
        },
        {
          path: "openstaand",
          component: OpenstaandView
        },
        {
          meta: { label: "Doorvoeren indexeringen" },
          path: "indexering",
          component: Indexeringen
        },
        {
          path: "export",
          component: ExcelExports,
          name: 'excel-exports',
          redirect: "export/opmerkingen",
          meta: { label: "Excel exports"},
            children: [
              {
                path: "opmerkingen",
                name: "opmerkingen-export",
                meta: { label: "Opmerkingen" },
                component: DownloadOpmerkingen
              },
              {
                path: "keuringspunten",
                name: "keuringspunten-export",
                meta: { label: "Keuringspunten" },
                component: DownloadKeuringsOpmerkingen
              },
              {
                path: "keuringen",
                name: "keuringen-export",
                meta: { label: "Keuringen" },
                component: DownloadKeuringen
              }
            ]
            
        },
        {
          path: "verkoop/:status",
          name: "Verkoop",
          props: true,
          component: Offertes,
          children: [
            {
              component: Offerte,
              path: "nieuw",
              meta: { 
                label: "Nieuwe offerte"
              },
              name: "NieuweOfferte",
            },
            {
              component: Offerte,
              path: "offerte/:id",
              props: route => ({ id: Number(route.params.id) }),
              name: "BewerkOfferte",
            },
            {
              component: Opdracht,
              path: "traject/:id",
              props: route => ({ id: Number(route.params.id) }),
              name: "Opdracht",
            }
          ]
        },
        {
          path: "/planning/herinspecties",
          name: "HerinspectiesInplannen",
          component: Herinspecties
        },
        {
          path: "/management",
          redirect: "/management/lopend"
        },
        {
          path: "/management/:status",
          name: "LiftManagement",
          props: true,
          component: LiftManagementView,
          children: [
            { 
              path: "nieuw",
              meta: {
                label: "Nieuw traject",
              },
              name: 'NieuwTraject',
              component: Traject
            },
            {
              path: "traject/:id",
              props: route => ({ id: Number(route.params.id) }),
              name: 'Traject',
              component: Traject
            }
          ]
        },
        {
          path: "/inspecties",
          name: "StatusInspecties",
          component: InspectiePrognosesView
        },
        {
          path: "facturatie",
          name: "Facturatie",
          redirect: "/facturatie/facturen/" + new Date().getFullYear(),
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "facturen/:jaar",
              name: "Facturen",
              props(route) {
                const props = { ...route.params };
                props.jaar = +props.jaar;
                return props;
              },
              component: Facturen
            },
            {
              path: "concept",
              name: "FactuurNieuw",
              meta: { label: "Nieuwe concept factuur" },
              props: true,
              component: Factuur
            },
            {
              path: "factuur/:id",
              name: "Factuur",
              props: true,
              component: Factuur
            }
          ]
        },
        {
          path: "keuringsrapporten/verwerkt",
          component: KeuringenVerwerkt,
          name: "Verwerkte keuringsrapporten",
        },
        {
          path: "keuringsrapporten",
          component: KeuringenQueue,
          name: "Keuringsrapporten",
        },
        {
          path: "keuring/:id",
          component: KeuringQueueDetail,
          name: "Keuringsrapport"
        },
        {
          path: "settings",
          redirect: "/settings/relaties",
          name: "Instellingen",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "relaties",
              name: "Relaties",
              component: Relaties
            },
            {
              path: "relaties/:id",
              name: "Relatie",
              component: Relatie,
              redirect: "relaties/:id/dashboard",
              props: route => ({ id: Number(route.params.id) }),
              children: [
                {
                  path: "dashboard",
                  meta: { label: "Dashboard" },
                  name: "RelatieDashboard",
                  props: true,
                  component: RelatieDashboard
                },
                {
                  path: "facturen/herinnering",
                  meta: { label: "Openstaande facturen" },
                  name: "RelatieOpenstaandeFacturen",
                  props: true,
                  component: RelatieHerinnering
                },
                {
                  path: "facturen/:jaar",
                  meta: { label: "Facturen van deze relatie" },
                  name: "RelatieFacturen",
                  props: true,
                  component: Facturen
                },
                
                {
                  path: "algemeen",
                  meta: { label: "Algemeen" },
                  name: "RelatieEdit",
                  props: true,
                  component: RelatieEdit
                },
                {
                  path: "import",
                  meta: { label: "Status import" },
                  name: "RelatieImportStatus",
                  props: route => ({ id: Number(route.params.id) }),
                  component: RelatieImportStatus
                },
                {
                  path: "documenten",
                  meta: { label: "Interne documenten" },
                  name: "RelatieDocumenten",
                  props: route => ({ id: Number(route.params.id) }),
                  component: RelatieDocumenten
                },
                {
                  path: "contactpersonen",
                  meta: { label: "Contactpersonen" },
                  name: "RelatieContactpersonen",
                  props: true,
                  component: RelatieContactpersonen
                },
                {
                  path: "units",
                  meta: { label: "Units" },
                  name: "RelatieUnits",
                  redirect: "units/overzicht",
                  props:true,
                  component: RelatieUnits,
                  children: [
                    {
                      path: "overzicht",
                      name: "RelatieUnitsOverzicht",
                      props: true,
                      component: RelatieUnitsOverzicht,
                    },
                    {
                      path: "financieel",
                      name: "RelatieUnitsFinancieel",
                      component: UnitsFinancieel,
                    },
                    {
                      path: "management",
                      name: "RelatieUnitsManagement",
                      component: RelatieUnitsData,
                    }
                  ]
                },
                {
                  path: "contracten",
                  meta: { label: "Contractdocumenten" },
                  name: "RelatieContractDocumenten",
                  props: route => ({ id: Number(route.params.id) }),
                  component: RelatieContractDocumenten
                },
                {
                  path: "api-keys",
                  meta: { label: "API-keys" },
                  name: "RelatieAPIKeys",
                  props: true,
                  component: RelatieAPIKeys
                }
              ]
            }
          ]
        },
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "login",
          name: "Login",
          component: Login
        },
      ]
    }
  ]
});

r.beforeEach(function(to, from, next) {
  if (store.getters.isAuthenticated || to.name === "Login") {
    if (from.name === "Prognose") {
      const answer = window.confirm(
        "Prognose verlaten? Mogelijke bewerkingen die niet zijn opgeslagen gaan verloren!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  } else {
    next("/pages/login");
  }
});

export default r;
